import React from 'react';
import { useTranslation } from 'react-i18next';
import { Button, Divider, Form, Input, Popconfirm } from 'antd';
import get from 'lodash/get';
import isEmpty from 'lodash/isEmpty';

import ColorPicker from '@components/controls/ColorPicker';

let timeoutId = null;

function EditPlaylistForm({
  initialValues,
  onRename,
  onChangeColor,
  onCopy,
  onDelete,
  withoutColor,
}) {
  const { t } = useTranslation();
  const onFieldsChange = (changedFields) => {
    if (isEmpty(changedFields)) return;
    clearTimeout(timeoutId);

    timeoutId = setTimeout(() => {
      const name = get(changedFields, [0, 'name', 0]);
      const value = get(changedFields, [0, 'value']);

      if (name === 'name') {
        onRename(value);
      } else {
        onChangeColor(value);
      }
    }, 300);
  };

  return (
    <div className="edit-playlist__content">
      <Form
        initialValues={initialValues}
        className="edit-playlist__form"
        name="edit-playlist"
        onFieldsChange={onFieldsChange}
      >
        <Form.Item name="name" className="edit-playlist__item">
          <Input className="edit-playlist__input" />
        </Form.Item>
        {!withoutColor && (
          <Form.Item name="color" noStyle className="edit-playlist__item">
            <ColorPicker popover />
          </Form.Item>
        )}
      </Form>
      <Divider className="edit-playlist__divider" />
      <div className="edit-playlist__actions">
        <Button onClick={onCopy} className="edit-playlist__item" type="link">
          {t('duplicate')}
        </Button>
        <Popconfirm
          placement="bottom"
          title={t('delete-content-warning')}
          cancelText={t('to-leave')}
          okText={t('delete')}
          onConfirm={onDelete}
        >
          <Button className="edit-playlist__item" type="link">
            {t('delete')}
          </Button>
        </Popconfirm>
      </div>
    </div>
  );
}

export default EditPlaylistForm;
